export default {
  height:'auto',
  // searchShow: true,
  searchMenuSpan:24,
  calcHeight: 'auto',
  tip: true,
  border: true,
  index: true,
  viewBtn: false,
  selection: false,
  addBtn: false,
  delBtn: false,
  editBtn: false,
  menu: true,
  menuWidth: 120,
  columnBtn: true,
  refreshBtn: true,
  stripe:true,
  column: [
    {
      label: '车场名称',
      type: 'tree',
      prop: 'spaceId',
      searchslot: true,
      hide: true,
      props: {
        label: 'title',
        value: 'key',
      },
      searchSpan: 6,
    },
    {
      label: '车场名称',
      prop: 'spaceName',
      width: 150,
    },
    {
      label: '区域名称',
      prop: 'regionName',
      span: 12,
    },
    {
      label: '车牌号',
      prop: 'carNo',
      width: 100,
      searchSpan: 6,
    },
    {
      label: '车辆分类',
      prop: 'carType',
      width: 100,
    },
    {
      label: '入场时间',
      prop: 'dateRange',
      searchSpan: 12,
      hide: true,
      searchslot: true,
      searchRange: true,
      width: 150,
      type: 'datetime',
      format: 'yyyy-MM-dd HH:mm:ss',
      valueFormat: 'yyyy-MM-dd HH:mm:ss',
    },
    {
      label: '入场时间',
      prop: 'inTime',
      width: 150,
      type: 'datetime',
      format: 'yyyy-MM-dd HH:mm:ss',
      valueFormat: 'yyyy-MM-dd HH:mm:ss',
    },
    // {
    //   label: '入场图片',
    //   prop: 'cloudCarImage_intoPark',
    //   slot: true,
    //   width: 80
    // },
    {
      label: '入场通道名称',
      prop: 'inPassageName',
    },
    {
      label: '是否出场',
      prop: 'outStatus',
    },
    {
      label: '入场备注',
      prop: 'inMemo',
      width: 300,
    },
    {
      label: '操作类型',
      prop: 'parkEventType',
      disabled: true,
      span: 8,
      type: 'select',
      dicUrl: '/api/blade-system/dict/dictionary?code=parkEventType',
      props: {
        label: 'dictValue',
        value: 'dictKey',
      },
      dataType: 'string',
    },
  ],
};
